"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionSettingsSchema = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const ROUNDING_METHOD_REQUIRED = "Please select a default rounding method";
const TAX_RESIDENCY_REQUIRED = "Please select a fund tax residency country";
const TAX_RESIDENCY_INVALID = "Please select a valid fund tax residency country";
const INVESTOR_TREATMENT_REQUIRED = "Please select an investor treatment";
const roundingMethodValues = Object.values(mystake_common_sdk_1.RoundingMethod);
const investorTreatmentValues = Object.values(mystake_common_sdk_1.InvestorTreatment);
/**
 * A fund switching distributions off may not have configured them yet, so the defaults are only
 * required while distributions are on. Values that are supplied are validated either way.
 */
const requiredWhileOn = (schema, message) => schema.when("allowDistributions", {
    is: false,
    then: (current) => current.notRequired(),
    otherwise: (current) => current.required(message),
});
// Forms hold "" for a blank select; treat it as unset so a switched-off fund can save without one.
const optionalText = () => yup.string().transform((value) => (value === "" ? undefined : value));
exports.DistributionSettingsSchema = yup.object().shape({
    allowDistributions: yup.boolean().optional(),
    allowReinvestment: requiredWhileOn(yup.boolean(), "Please select whether reinvestment is allowed"),
    roundingMethod: requiredWhileOn(optionalText().trim(ROUNDING_METHOD_REQUIRED).oneOf(roundingMethodValues, ROUNDING_METHOD_REQUIRED), ROUNDING_METHOD_REQUIRED),
    taxResidencyCountryCode: requiredWhileOn(optionalText()
        .trim(TAX_RESIDENCY_REQUIRED)
        .uppercase()
        .length(3, TAX_RESIDENCY_INVALID)
        .test("valid-alpha3", TAX_RESIDENCY_INVALID, (value) => value === undefined || value === null || mystake_common_sdk_1.COUNTRY_ALPHA3_CODES.has(value)), TAX_RESIDENCY_REQUIRED),
    investorTreatment: requiredWhileOn(optionalText().trim(INVESTOR_TREATMENT_REQUIRED).oneOf(investorTreatmentValues, INVESTOR_TREATMENT_REQUIRED), INVESTOR_TREATMENT_REQUIRED),
});
//# sourceMappingURL=DistributionSettingsSchema.js.map